import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer({ setPage }) {
    return (
        <footer className="site-footer mt-auto">
            <Container>
                <Row className="gy-4">
                    <Col lg={4} md={12} className="mb-3 mb-lg-0">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <img src="qcoda_icon_white.png" alt="Qcoda Logo" height="30" className="rounded" />
                            <span className="fw-bold fs-5">Qcoda</span>
                        </div>
                        <p className="text-dim" style={{ fontSize: '0.875rem', maxWidth: '280px', margin: 0 }}>
                            Product orchestration for aligned engineering.
                        </p>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">Company</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <button onClick={() => setPage('home')} className="bg-transparent border-0 p-0" style={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>Home</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={() => setPage('contact')} className="bg-transparent border-0 p-0" style={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>Contact</button>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">Resources</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <a href="https://hackernoon.com/alignment-driven-development-the-orchestration-framework-ai-paired-coding-forgot-to-build" target="_blank" rel="noopener noreferrer">Blog</a>
                            </li>
                            <li className="mb-2">
                                <a href="https://llmesh.net" target="_blank" rel="noopener noreferrer">LLMesh</a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">Connect</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <a href="https://x.com/qcoda_ai" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
                            </li>
                            <li className="mb-2">
                                <a href="https://www.linkedin.com/company/qcoda" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                            </li>
                            <li className="mb-2">
                                <a href="mailto:hello@qcoda.com">hello@qcoda.com</a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                        <p className="footer-heading">Legal</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <button onClick={() => setPage('privacy')} className="bg-transparent border-0 p-0" style={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>Privacy Policy</button>
                            </li>
                            <li className="mb-2">
                                <button onClick={() => setPage('terms')} className="bg-transparent border-0 p-0" style={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>Terms of Service</button>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className="mt-4 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <Col className="text-center text-dim" style={{ fontSize: '0.8rem' }}>
                        &copy; {new Date().getFullYear()} Qcoda LLC. All rights reserved.
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
